"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      name = _ref.name,
      value = _ref.value,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["classes", "children", "name", "value", "onChange", "disabled"]);

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), children.map(function (radioOption) {
    var optionValue = radioOption.props.value;
    return _react["default"].cloneElement(radioOption, {
      key: optionValue,
      id: "".concat(name, "-").concat(optionValue),
      name: name,
      disabled: disabled,
      selected: optionValue === value,
      onChange: function onChange(e) {
        return _onChange(e, optionValue);
      }
    });
  }));
};

RadioButtonGroup.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of RadioButtonGroup component */
  children: _propTypes["default"].node.isRequired,

  /** Prop used to bind RadioButtons to RadioButtonGroup */
  name: _propTypes["default"].string.isRequired,

  /** Prop used to mark RadioButton as selected */
  value: _propTypes["default"].string,

  /** RadioButtonGroup onChange callback */
  onChange: _propTypes["default"].func,

  /** Bool flag to enable/disable the RadioButtonGroup */
  disabled: _propTypes["default"].bool
};
RadioButtonGroup.defaultProps = {
  value: null,
  onChange: function onChange() {},
  disabled: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(RadioButtonGroup);

exports["default"] = _default;